/*
 * Flushes the onJQuery() queue once the deferred jQuery has executed.
 *
 * jQuery is loaded with `defer`, so it runs after the document is parsed — but the
 * inline blocks that use `$` run *during* parsing, before it. The stub defined in
 * the <head> collects those callbacks; this file (also deferred, and after jQuery in
 * document order, so it always runs later) hands them the real jQuery and replaces
 * the stub so anything registering afterwards runs immediately.
 *
 * Deferred scripts run before DOMContentLoaded, so $(document).ready() callbacks
 * registered from here still fire normally.
 */
(function () {
  var queue = window.__jqq || [];

  window.onJQuery = function (cb) {
    cb(window.jQuery);
  };

  for (var i = 0; i < queue.length; i++) {
    try {
      queue[i](window.jQuery);
    } catch (e) {
      console.error('onJQuery callback failed:', e);
    }
  }

  window.__jqq = [];
})();
